export const IconCalendarPublication20: {
  name: 'icon_calendar_publication_20-f32f0da86387'
} = {
  name: 'icon_calendar_publication_20-f32f0da86387'
}
